"use client";

import { useRef } from "react";

import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Heading, Text } from "@/src/components/ui/Typography";
import { StickyColumnUntilLevel } from "@/src/components/molecules/StickyColumnUntilLevel";

interface ClientBackgroundProps {
  paragraphs: string[];
}

export function ClientBackground({ paragraphs }: ClientBackgroundProps) {
  const boundsRef = useRef<HTMLDivElement>(null);

  if (paragraphs.length === 0) return null;

  return (
    <Section className="bg-white">
      <Container>
        <div className="grid gap-6 md:grid-cols-2 md:gap-24">
          <StickyColumnUntilLevel boundsRef={boundsRef} className="h-fit self-start">
            <Heading as="h2" size="displayLG">
              Client Background
            </Heading>
          </StickyColumnUntilLevel>

          <div ref={boundsRef} className="flex flex-col gap-6">
            {paragraphs.map((paragraph, index) => (
              <Text key={index} size="bodyLG" className="text-neutral-700">
                {paragraph}
              </Text>
            ))}
          </div>
        </div>
      </Container>
    </Section>
  );
}
